import { DateTime } from 'luxon'

import parseFormattedNumber from './FormattedNumberParser'
import { parseEveTimestamp } from './EveDateParser'

class IncursionPayout {
  readonly timestamp: DateTime
  readonly isk: number
  readonly loyaltyPoints: number

  constructor(timestamp: DateTime, isk: number, loyaltyPoints: number) {
    this.timestamp = timestamp
    this.isk = isk
    this.loyaltyPoints = loyaltyPoints
  }
}

const parseIncursionPayouts = (text: string): Array<IncursionPayout> => {
  return text.split('\n')
    .map(line => line.split('\t'))
    .filter(line => line.length >= 3)
    .filter(line => line[1] === 'Corporate Reward Payout')
    .map(line => new IncursionPayout(parseEveTimestamp(line[0]), parseFormattedNumber(line[2]) as number, -1))
}

export { IncursionPayout, parseIncursionPayouts }
